import { Fragment } from "react";

import { css } from "@compiled/react";
import { FormattedMessage } from "react-intl";

import { getColor } from "@atlassiansox/wpl-utils";

import { PriceFinderMessages } from "../constants";

import { centerJustifiedStyling } from "./card-container";
import { PriceDisplay } from "./price-display";

export type FreeProps = {
    formattedZeroPrice: string;
    fontSize: string;
    planName: string;
    messages: PriceFinderMessages;
};

const freeContainerStyles = css(centerJustifiedStyling);

const freeDescriptionStyles = css({
    fontSize: "16px",
    lineHeight: "24px"
});

const monthlySubscriptionTextStyles = css({
    fontSize: "16px",
    lineHeight: "24px",
    fontWeight: "bold",
    marginBlockEnd: "32px",
    color: getColor("n900")
});

export const Free = ({
    planName,
    formattedZeroPrice,
    fontSize,
    messages
}: FreeProps) => (
    <Fragment>
        <PriceDisplay
            planName={planName}
            formattedPrice={formattedZeroPrice}
            fontSize={fontSize}
        />
        <div css={freeContainerStyles}>
            <div css={freeDescriptionStyles}>
                <FormattedMessage {...messages.cardFreeDescription} />
            </div>
            <div css={monthlySubscriptionTextStyles}>
                <FormattedMessage
                    id="Pricing.PriceCard.Free.MonthlySubscription"
                    defaultMessage="monthly subscription only"
                />
            </div>
        </div>
    </Fragment>
);
